module.exports = __webpack_public_path__ + "static/media/Shape.0a4a9024.svg";